import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import entityComposition from '../common/classes/entityComposition';
import UnsavedChangesNotification from './unsavedChangesNotification';
import UploadNotification from './uploadNotification';
import GeneralNotification from './generalNotification';

// must be defined outside of the component to avoid re-rendering loops
const defaultLeftButtonAction = () => {};
const defaultMiddleButtonAction = () => {};
const defaultRightButtonAction = () => {};
const Toaster = ({
  notificationActions: {
    dismiss
  },
  list: notificationList
}) => /*#__PURE__*/React.createElement("div", {
  className: classnames('tqc-toast-container', 't-toast-container')
}, notificationList.map((toast, index) => {
  const {
    id,
    settings: {
      showCloseButton,
      autoClose
    },
    content: {
      files,
      failedToUpload,
      noAction,
      yesAction,
      headerMessage,
      messageType = 'info',
      message,
      hint,
      technicalDetail,
      reference,
      errorCode,
      list,
      leftButtonAction = defaultLeftButtonAction,
      leftButtonLabel,
      middleButtonAction = defaultMiddleButtonAction,
      middleButtonLabel,
      rightButtonAction = defaultRightButtonAction,
      rightButtonLabel
    }
  } = toast;

  // setup autoClose for components that don't have it disabled
  // could move this to the reducer layer and do a true update
  // (reset of timer) when a new one comes in with the same id
  if (autoClose && autoClose > 0) {
    setTimeout(() => dismiss(id), autoClose);
  }
  let toastComponent;
  switch (messageType) {
    case 'save':
      toastComponent = /*#__PURE__*/React.createElement(UnsavedChangesNotification, {
        key: id,
        noAction: noAction,
        yesAction: yesAction,
        close: () => dismiss(id)
      });
      break;
    case 'upload':
      toastComponent = /*#__PURE__*/React.createElement(UploadNotification, {
        key: id,
        handleClose: () => dismiss(id),
        files: files,
        failedToUpload: failedToUpload
      });
      break;
    default:
      toastComponent = /*#__PURE__*/React.createElement(GeneralNotification, {
        key: id,
        headerMessage: headerMessage,
        messageType: messageType,
        message: message,
        hint: hint,
        technicalDetail: technicalDetail,
        reference: reference,
        errorCode: errorCode,
        list: list,
        leftButtonLabel: leftButtonLabel,
        leftButtonAction: () => {
          leftButtonAction();
          dismiss(id);
        },
        middleButtonLabel: middleButtonLabel,
        middleButtonAction: () => {
          middleButtonAction();
          dismiss(id);
        },
        rightButtonLabel: rightButtonLabel,
        rightButtonAction: () => {
          rightButtonAction();
          dismiss(id);
        }
      });
  }
  return /*#__PURE__*/React.createElement("div", {
    key: id,
    className: classnames('tqc-toast-notification', 't-toast-notification')
  }, /*#__PURE__*/React.createElement("div", {
    className: "tqc-toast-content"
  }, toastComponent), showCloseButton && /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: classnames('tqc-toast-close-button', `t-toast-close-button-${index}`),
    onClick: () => dismiss(id)
  }, "\u2716"));
}));
Toaster.propTypes = {
  notificationActions: PropTypes.shape({
    dismiss: PropTypes.func
  }).isRequired,
  list: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export { Toaster as TestToaster };
export default entityComposition(Toaster, [], {}, ['notification']);